import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {captureItemsPaypalPayment} from "../api/apiClient";
import {useCartContext} from "../contexts/CartContext";
import PaymentConfirmation from "../components/PaymentConfirmation";
import {trackEvent} from "../utils/fbPixel";

const ShopPaypalConfirmationPage = () => {
    const [searchParams] = useSearchParams();
    const [paymentStatus, setPaymentStatus] = useState(null); // null, "success", "general_error"
    const {clearCart} = useCartContext();

    useEffect(() => {
        const paypalOrderId = searchParams.get("token");

        if (paypalOrderId) {
            captureItemsPaypalPayment(paypalOrderId)
                .then((data) => {
                    if (data === "success") {
                        setPaymentStatus("success");
                        clearCart();
                        trackEvent('Purchase', {currency: 'EUR'});
                    }
                    else {
                        setPaymentStatus("general_error");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setPaymentStatus("general_error");
                });
        }
    }, [searchParams, clearCart]);

    return (
        <PaymentConfirmation
            paymentStatus={paymentStatus}
            paymentProvider="PayPal"
            backTo="/shop"
            backLabel="ZURÜCK ZUM SHOP"
            generalErrorMessage="Die gewünschten Artikel wurden nicht gekauft."
        />
    );
};

export default ShopPaypalConfirmationPage;
